import { __assign } from 'tslib';
import * as React from 'react';
import { UitkPagingPrevButton, UitkPagingNextButton } from 'uitk-react-button';
import { classNames } from 'uitk-react-utils';
import { debounce } from 'throttle-debounce';
import styles from './uitk-carousel.css';
import { UitkCarouselLocalAnalyticsIdType } from './uitk-carousel.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkCarouselNav = function (props) {
    var analytics = props.analytics, buttonText = props.buttonText, carouselName = props.carouselName, currentIndex = props.currentIndex, itemCount = props.itemCount, itemsVisible = props.itemsVisible, fullSheetVisible = props.fullSheetVisible, loop = props.loop, navigationIconId = props.navigationIconId, onNextCb = props.onNextCb, onPrevCb = props.onPrevCb, pagingOverlay = props.pagingOverlay, peek = props.peek, size = props.size, isRtl = props.isRtl;
    var currentItemsVisible = itemsVisible[size];
    var prevBtnClassNames = getClassNameList('uitk-carousel-button-paging', 'uitk-carousel-button-prev', typeof window !== 'undefined' && 'ontouchstart' in window && peek && 'is-visually-hidden');
    var nextBtnClassNames = getClassNameList('uitk-carousel-button-paging', 'uitk-carousel-button-next', typeof window !== 'undefined' && 'ontouchstart' in window && peek && 'is-visually-hidden');
    var nextBtnRef = React.useRef(null);
    var prevBtnRef = React.useRef(null);
    // Fixes issue on mobile devices where touch events trigger paging events multiple times
    var DEBOUNCE_TIMER = typeof window !== 'undefined' && 'ontouchstart' in window ? 50 : 0;
    var clickLeftAnalytics = analytics && __assign({ localAnalyticsId: "".concat(carouselName, ".Carousel.").concat(UitkCarouselLocalAnalyticsIdType.clickLeft) }, analytics);
    var clickRightAnalytics = analytics && __assign({ localAnalyticsId: "".concat(carouselName, ".Carousel.").concat(UitkCarouselLocalAnalyticsIdType.clickRight) }, analytics);
    var focusNavigationBtn = function (ref) {
        /* istanbul ignore else */
        if (ref && ref.current) {
            ref.current.focus();
        }
    };
    var onPrev = debounce(DEBOUNCE_TIMER, function () {
        /* istanbul ignore else */
        onPrevCb && onPrevCb();
        if (currentItemsVisible > 0 && currentIndex === 1) {
            focusNavigationBtn(prevBtnRef);
        }
    });
    var onNext = debounce(DEBOUNCE_TIMER, function () {
        /* istanbul ignore else */
        onNextCb && onNextCb();
        if (currentItemsVisible > 0 && currentIndex === itemCount - currentItemsVisible - 1) {
            focusNavigationBtn(nextBtnRef);
        }
    });
    var onKeyboardEvent = React.useCallback(function (e) {
        /* istanbul ignore else */
        if (isRtl) {
            /* istanbul ignore else */
            if (e.key === 'ArrowLeft') {
                onNext();
            }
            else if (e.key === 'ArrowRight') {
                onPrev();
            }
        }
        else if (e.key === 'ArrowLeft') {
            onPrev();
        }
        else if (e.key === 'ArrowRight') {
            onNext();
        }
    }, 
    // Linter states that onNext & onPrev should be dependencies here (eslint-plugin-react-hooks/exhaustive-deps)
    [isRtl, onNext, onPrev]);
    var renderNav = function () {
        if (itemCount > currentItemsVisible) {
            var isPrevBtnDisabled = !loop && currentIndex === 0;
            var isNextBtnDisabled = !loop && currentIndex === itemCount - currentItemsVisible;
            return (React.createElement("div", { className: getClassNameList('uitk-carousel-controls') },
                React.createElement(UitkPagingPrevButton, { analytics: clickLeftAnalytics, className: prevBtnClassNames, iconId: navigationIconId === null || navigationIconId === void 0 ? void 0 : navigationIconId.prev, iconTitle: buttonText.prevButton, onClick: onPrev, domRef: prevBtnRef, "data-stid": "carousel-nav-prev", "aria-disabled": isPrevBtnDisabled, "aria-label": buttonText.prevButton, tabIndex: isPrevBtnDisabled ? -1 : 0, pagingOverlay: pagingOverlay }),
                React.createElement(UitkPagingNextButton, { analytics: clickRightAnalytics, className: nextBtnClassNames, iconId: navigationIconId === null || navigationIconId === void 0 ? void 0 : navigationIconId.next, iconTitle: buttonText.nextButton, onClick: onNext, domRef: nextBtnRef, "data-stid": "carousel-nav-next", "aria-disabled": isNextBtnDisabled, "aria-label": buttonText.nextButton, tabIndex: isNextBtnDisabled ? -1 : 0, pagingOverlay: pagingOverlay })));
        }
        return null;
    };
    React.useEffect(function () {
        if (fullSheetVisible) {
            document.body.addEventListener('keydown', onKeyboardEvent);
            return function () {
                document.body.removeEventListener('keydown', onKeyboardEvent);
            };
        }
        // Linter states that onKeyboardEvent should be a dependency here (eslint-plugin-react-hooks/exhaustive-deps)
    }, [fullSheetVisible, onKeyboardEvent]);
    return renderNav();
};
UitkCarouselNav.displayName = 'UitkCarouselNav';

export { UitkCarouselNav };
